export enum StorageSelectProductsActionTypes {
  STORAGE_ADD_PRODUCT = "STORAGE_ADD_PRODUCT",
  STORAGE_REMOVE_PRODUCT = "STORAGE_REMOVE_PRODUCT",
  STORAGE_UPDATE_QTY_PER_CASE = "STORAGE_UPDATE_QTY_PER_CASE",
  STORAGE_UPDATE_NUMBER_OF_CASES = "STORAGE_UPDATE_NUMBER_OF_CASES",
  STORAGE_ADD_PRODUCT_DETAILS = "STORAGE_ADD_PRODUCT_DETAILS",
  STORAGE_ADD_BULK_UPLOAD_PRODUCT = "STORAGE_ADD_BULK_UPLOAD_PRODUCT",
}
